/** How a bulk run's scenarios came out, counted once for the summary tiles and the history rows alike. */

import type { BulkRunItem } from '@/types/websocket.types';
import { itemOutcome } from './item-outcome';

interface RunCounts {
	/** Done or failed: no longer waiting or running. */
	settled: number;
	/** Judged Perfect, or marked Correct by a person. */
	perfect: number;
	/** Judged short of Perfect, or marked Incorrect. */
	flagged: number;
	/** Done with nothing judging it yet: no human reply to compare, or the judge failed, and nobody marked it. */
	unjudged: number;
	/** Done with at least one simulated write. */
	wrote: number;
	failed: number;
}

export const runCounts = (items: BulkRunItem[]): RunCounts => {
	const outcomes = items.map(itemOutcome);
	const count = (...wanted: ReturnType<typeof itemOutcome>[]) =>
		outcomes.filter((each) => wanted.includes(each)).length;
	const failed = count('failed');
	return {
		settled: items.filter((item) => item.status === 'done').length + failed,
		perfect: count('passed'),
		flagged: count('flagged', 'incorrect'),
		unjudged: count('unjudged'),
		wrote: items.filter((item) => item.status === 'done' && item.simulatedWrites.length > 0).length,
		failed
	};
};
